'use client'

import Link from 'next/link'
import { useRouter } from 'next/navigation'
import * as React from 'react'

import TopRanking from '@/app/(main)/home/components/top-ranking'
import ArrowRight from '@/components/icons/arrow-right.svg'
import Nickname from '@/components/nickname'
import RankingTitle from '@/components/ranking-title'
import Avatar from '@/components/ui/avatar'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import {
  formatPercent,
  formatPrice,
} from '@/lib/formatter'
import { useReadRankingInfiniteQuery } from '@/redux/ranking'

export default function Ranking() {
  const { data } = useReadRankingInfiniteQuery()
  const { rows, total, competition } = data?.pages[0] || { rows: [], total: 0 }
  const router = useRouter()

  return (
    <div className="w-(--content-width) mx-auto relative z-1 bg-[url('/home-images/top-rankings-background.png')] bg-size-[74.99994rem_27.5955rem] bg-no-repeat bg-position-[center_70px]">
      <RankingTitle competition={competition} className="mb-22" />
      <div className="flex justify-between items-end w-[65rem] mx-auto">
        <TopRanking ranking={rows[1]} index={2} />
        <TopRanking ranking={rows[0]} index={1} />
        <TopRanking ranking={rows[2]} index={3} />
      </div>
      {total > 0 && (
        <Table className="mt-12 border-spacing-y-0">
          <TableHeader className="bg-[url('/home-images/ranking-table-header.png')] bg-contain bg-no-repeat">
            <TableRow className="text-secondary-foreground *:px-8 *:py-[18px]">
              <TableHead className="text-center">Rank</TableHead>
              <TableHead>Contributors</TableHead>
              <TableHead className="text-center">P&L</TableHead>
              <TableHead className="text-center">ROI</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.slice(3).map(({ ranking, user, roi, pnl }) => (
              <TableRow
                className="hover:bg-linear-to-r hover:from-gradient-blue hover:to-gradient-purple cursor-pointer *:px-10 *:py-3"
                key={ranking}
                onClick={() => {
                  if (!user) return
                  router.push(`/account/${user.id}`)
                }}
              >
                <TableCell className="font-bold text-center">
                  {ranking}
                </TableCell>
                <TableCell className="flex items-center gap-3">
                  <Avatar size="sm" src={user?.avatar} />
                  <Nickname user={user} />
                </TableCell>
                <TableCell className="text-center">{formatPrice()(pnl)}</TableCell>
                <TableCell className="text-center">{formatPercent()(roi)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
      <div className="text-center mt-8">
        <Link href="/leaderboard" className="h-10 w-[7.75rem] bg-[url('/home-images/view-event-button-border.png')] rounded-full inline-flex gap-1 items-center justify-center bg-no-repeat bg-contain bg-[#f0f0f0]/10 hover:bg-[#f0f0f0]/15">
          <span>View All</span>
          <ArrowRight className="size-5 fill-white" />
        </Link>
      </div>
    </div>
  )
}
